import React from "react";
import { Container } from "react-bootstrap";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import DeepLink from "./../DeepLink";

import { PayloadSubjectUtils } from "./IPayloadProps";

export interface IInsuranceInfoProps {
  payload: AuthorizationResponsePayload;
  signalIfValid: (isValid: boolean) => void;
  onUpdateInsuranceInfo: (amount: string, duration: string) => void;
  amountOptions?: any;
  durationOptions?: any;
  selectedAmount?: string;
  selectedDuration?: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IInsuranceInfoProps) => {
  const subjects = new PayloadSubjectUtils();
  props.signalIfValid(true);

  let onAmountChanged = (amountNew: string) => {
    props.onUpdateInsuranceInfo(amountNew, props.selectedDuration ? props.selectedDuration : "");
  };
  let onDurationChanged = (durationNew: string) => {
    props.onUpdateInsuranceInfo(props.selectedAmount ? props.selectedAmount : "", durationNew);
  };

  let renderAmountOptions = () => {
    if (props.amountOptions != null) {
      return props.amountOptions.map((opt: string, index: number) => (
        <option key={`${opt}-${index}`} value={opt}>
          {opt}
        </option>
      ));
    }
  };

  let renderDurationOptions = () => {
    if (props.durationOptions != null) {
      return props.durationOptions.map((duration: string, index: number) => (
        <option key={`${duration}-${index}`} value={duration}>
          {duration}
        </option>
      ));
    }
  };

  return (
    <Container
      fluid
      style={{
        margin: "auto",
        width: "50%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <span>Insured amount</span>
        <select
          style={{ width: "200px", marginLeft: "auto" }}
          value={props.selectedAmount ? props.selectedAmount : ""}
          onChange={(event) => onAmountChanged(event.currentTarget.value)}
        >
          <option value="">100.000 CHF</option>
          {renderAmountOptions()}
        </select>
      </Container>
      <Container
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          marginTop: "50px",
        }}
      >
        <span>Policy contract duration</span>
        <select
          style={{ width: "200px", marginLeft: "auto" }}
          value={props.selectedDuration ? props.selectedDuration : ""}
          onChange={(event) => onDurationChanged(event.currentTarget.value)}
        >
          <option value="">1 year</option>
          {renderDurationOptions()}
        </select>
      </Container>
    </Container>
  );
};
